import { pageRouting } from './pageUrl';
//쿠키 호출
import { cookies } from '../assets/lib/cookies';
//레이아웃 콜
import { baseFrame } from '../../layout/layout';
//페이지 라우팅
import { pageMoveController } from './setting.core';
import { fileLoadFrame } from './pageFileCall';

//페이지 이동 이벤트 세트
function routingSet(param) {
	fileLoadFrame.init(param);
	baseFrame.init(param);
	pageMoveController.init(param);
}


//페이지 라우팅 코어
export function pageRoutingCore(param) {
	$('#container').hide();
	param = param.replace('#','');
	routingSet(param);
}

//브라우저 히스토리 저장기능(앞으로가기 뒤로가기)
function browserHistoryApi(param) {
	window.history.pushState(null, null, param);
}
var saveAdvId = null;
var saveSubID = null;
var saveDate1 = null;
var saveDate2 = null;
///초기 로딩 설정
function routingPackageController(param) {
	var userCheck = cookies.getCookies('user_id');
	var hashParam = document.location.hash;
	var hashLoginPage = '#' + pageRouting[0].url;
	if(hashParam == '') {
		hashParam = '#/index';
		location.href = '#/index';
	}else if((hashParam != hashLoginPage) && userCheck == null) {
		alert('로그인 후 이용 가능합니다');
		hashParam = hashLoginPage;
		location.href = hashLoginPage;
	}else if((hashParam == hashLoginPage) && userCheck != null) {
		alert('접속 상태 입니다.');
		hashParam = '#/index';
		location.href = '#/index';
	}else{
		 pageRoutingCore(hashParam);
	}
}
routingPackageController();

//이동 이벤트 라우팅
window.addEventListener('hashchange', function(e) {
	routingPackageController();
});





//글로벌 이벤트
window.pageRoutingCore = pageRoutingCore;


// WEBPACK FOOTER //
// ./js/controller/route/route.js